var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", {
        staticClass: "overlay",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _vm.name === "stores"
        ? _c("div", {
            staticClass: "overlay",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$root.$emit("goToStores")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container",
            class: { "mw-500": _vm.name === "upload" }
          },
          [
            _c(
              "div",
              { staticClass: "modal-header" },
              [
                _vm.name !== "stores"
                  ? _vm._t("header", [
                      _vm._v("\n            default header\n          ")
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm._t("body", [
                  _vm._v("\n            default body\n          ")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm.name === "upload"
                  ? _vm._t("footer", [
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button cancel",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("\n              Close\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button submit",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$root.$emit("submit")
                            }
                          }
                        },
                        [_vm._v("\n              Submit\n            ")]
                      )
                    ])
                  : _vm.name === "storesSelect"
                  ? _vm._t("footer", [
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button cancel",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("\n              Close\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button submit",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$root.$emit("next")
                            }
                          }
                        },
                        [_vm._v("\n              Next\n            ")]
                      )
                    ])
                  : _vm.name === "stores"
                  ? _vm._t("footer", [
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button close",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$root.$emit("select")
                            }
                          }
                        },
                        [_vm._v("\n              OK\n            ")]
                      )
                    ])
                  : _vm._t("footer", [
                      _c(
                        "button",
                        {
                          staticClass: "modal-default-button close",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("\n              OK\n            ")]
                      )
                    ])
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eaeaf66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eaeaf66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = null
// module chunks = 